(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-kaseme-collective"]) return;
  try {
    
  (() => {
    const requests = new WeakMap();
    document.addEventListener('change', async (event) => {
      const selector = event.target.closest('[data-kaseme-option]');
      if (!selector) return;
      const root = selector.closest('[data-kaseme-product]');
      if (!root) return;
      const optionIds = Array.from(root.querySelectorAll('[data-kaseme-option]'), (item) => item.value);
      const pageUrl = new URL(window.location.href);
      pageUrl.searchParams.delete('variant');
      pageUrl.searchParams.set('option_values', optionIds.join(','));
      const renderUrl = new URL(pageUrl);
      renderUrl.searchParams.set('section_id', root.dataset.sectionId);
      const previous = requests.get(root);
      if (previous) previous.abort();
      const controller = new AbortController();
      requests.set(root, controller);
      root.setAttribute('aria-busy', 'true');
      root.querySelector('button[type=submit]').disabled = true;
      const quantity = root.querySelector('[name=quantity]').value;
      const focusedPosition = selector.dataset.optionPosition;
      try {
        let replacement;
        for (let attempt = 0; attempt < 4; attempt++) {
          const response = await fetch(renderUrl.toString(), { signal: controller.signal });
          if (!response.ok) throw new Error('Section unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          replacement = html.getElementById(root.id);
          if (!replacement) throw new Error('Product section missing');
          const availableSelection = Array.from(replacement.querySelectorAll('[data-kaseme-option]'), (item) => item.value).filter(Boolean).join(',');
          if (replacement.dataset.variantAvailable === 'true' || replacement.dataset.productAvailable !== 'true') break;
          if (!availableSelection || availableSelection === renderUrl.searchParams.get('option_values')) throw new Error('Available selection missing');
          pageUrl.searchParams.set('option_values', availableSelection);
          renderUrl.searchParams.set('option_values', availableSelection);
        }
        if (replacement.dataset.productAvailable === 'true' && replacement.dataset.variantAvailable !== 'true') throw new Error('Available variant missing');
        if (controller.signal.aborted) return;
        const existingUpsell = root.querySelector("[data-kaseme-upsell]");
        root.innerHTML = replacement.innerHTML;
        const refreshedUpsell = root.querySelector("[data-kaseme-upsell]");
        if (existingUpsell && refreshedUpsell) refreshedUpsell.replaceWith(existingUpsell);
        syncDuoOffer();
        root.dataset.variantId = replacement.dataset.variantId;
        root.dataset.variantAvailable = replacement.dataset.variantAvailable;
        root.dataset.productAvailable = replacement.dataset.productAvailable;
        root.querySelector('[name=quantity]').value = quantity;
        if (replacement.dataset.variantId) {
          pageUrl.searchParams.delete('option_values');
          pageUrl.searchParams.set('variant', replacement.dataset.variantId);
        }
        window.history.replaceState({}, '', pageUrl.toString());
        const focusedOption = root.querySelector('[data-option-position="' + focusedPosition + '"]');
        if (focusedOption) focusedOption.focus();
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(pageUrl.toString());
      } finally {
        if (requests.get(root) === controller) {
          root.removeAttribute('aria-busy');
          requests.delete(root);
        }
      }
    });
    const popupId = '316913';
    let offerPending = false;
    const getPopup = () => window.Rebuy && Array.isArray(window.Rebuy.widgets)
      ? window.Rebuy.widgets.find((widget) => String(widget.id) === popupId) : null;
    const preparePopup = (event) => {
      const widget = event.detail && event.detail.widget;
      if (widget && String(widget.id) === popupId && widget.data) widget.data.pop_up_trigger = 'manual';
    };
    document.addEventListener('rebuy.init', preparePopup);
    document.addEventListener('rebuy.beforeReady', preparePopup);
    document.addEventListener('rebuy.ready', preparePopup);
    const existingPopup = getPopup();
    if (existingPopup && existingPopup.data) existingPopup.data.pop_up_trigger = 'manual';
    const showCart = () => {
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
        window.Rebuy.SmartCart.show();
      } else {
        const root = document.querySelector('[data-kaseme-product]');
        window.location.assign(root ? root.dataset.cartUrl : '/cart');
      }
    };
    const setDuoInCart = (duoId, inCart) => {
      document.querySelectorAll('[data-kaseme-product]').forEach((root) => {
        if (root.dataset.duoId !== String(duoId)) return;
        root.dataset.duoInCart = String(inCart);
        const upsell = root.querySelector('[data-kaseme-upsell]');
        if (upsell) upsell.hidden = inCart;
        if (inCart && offerPending) {
          offerPending = false;
          const popup = getPopup();
          if (popup) popup.hide();
        }
      });
    };
    const syncDuoItems = (items) => {
      if (!Array.isArray(items)) return;
      document.querySelectorAll('[data-kaseme-product]').forEach((root) => {
        const duoId = root.dataset.duoId;
        if (!duoId) return;
        const inCart = items.some((item) => String(item.product_id || (item.product && item.product.id)) === duoId && Number(item.quantity) > 0);
        setDuoInCart(duoId, inCart);
      });
    };
    const syncDuoOffer = (event) => {
      const cartModule = event && event.detail && event.detail.cart;
      let items = cartModule && cartModule.cart && cartModule.cart.items;
      if (!Array.isArray(items) && window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.getItems === 'function') {
        items = window.Rebuy.Cart.getItems();
      }
      syncDuoItems(items);
    };
    const waitForDuoPopup = async (duoId) => {
      const deadline = Date.now() + 6000;
      do {
        const popup = getPopup();
        const container = document.querySelector('[data-kaseme-popup]');
        if (popup && container && container.dataset.rebuyShopifyProductIds === String(duoId)
          && container.querySelector('.rebuy-product-block')
          && typeof popup.shouldDisplay === 'function' && popup.shouldDisplay()
          && typeof popup.getProductIDs === 'function'
          && popup.getProductIDs().map(String).includes(String(duoId))) return popup;
        await new Promise((resolve) => window.setTimeout(resolve, 100));
      } while (Date.now() < deadline);
      return null;
    };
    document.addEventListener('rebuy:cart.ready', syncDuoOffer);
    document.addEventListener('rebuy:cart.change', syncDuoOffer);
    document.addEventListener('rebuy.ready', syncDuoOffer);
    document.addEventListener('rebuy.show', (event) => {
      const widget = event.detail && event.detail.widget;
      const root = document.querySelector('[data-kaseme-product]');
      if (widget && String(widget.id) === popupId && root && root.dataset.duoInCart === 'true') {
        offerPending = false;
        widget.hide();
      }
    });
    document.addEventListener('rebuy.add', (event) => {
      const widget = event.detail && event.detail.widget;
      const product = event.detail && event.detail.product;
      if (!widget || !product || !['316906', popupId].includes(String(widget.id))) return;
      const duoId = String(product.product_id || product.id);
      const root = Array.from(document.querySelectorAll('[data-kaseme-product]')).find((item) => item.dataset.duoId === duoId);
      if (!root) return;
      setDuoInCart(duoId, true);
      if (String(widget.id) === popupId) window.setTimeout(() => widget.hide(), 0);
    });
    syncDuoOffer();
    document.addEventListener('rebuy.hide', (event) => {
      const widget = event.detail && event.detail.widget;
      if (!widget || String(widget.id) !== popupId || !offerPending) return;
      offerPending = false;
      window.setTimeout(showCart, 0);
    });
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.kaseme-product__form');
      if (!form) return;
      const root = form.closest('[data-kaseme-product]');
      if (!root) return;
      if (root.getAttribute('aria-busy') === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!root.dataset.duoId || !document.querySelector('[data-kaseme-popup]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = form.querySelector('button[type=submit]');
      const status = form.querySelector('[data-kaseme-cart-status]');
      const originalLabel = button.textContent;
      const formData = new FormData(form);
      const controls = Array.from(form.querySelectorAll('select, input[name=quantity], button[type=submit]'));
      controls.forEach((control) => { control.disabled = true; });
      root.setAttribute('aria-busy', 'true');
      status.textContent = '';
      status.hidden = true;
      let added = false;
      try {
        const addUrl = new URL(form.action);
        addUrl.pathname = addUrl.pathname.replace(/\/add\/?$/, '/add.js');
        const response = await fetch(addUrl.toString(), {
          method: 'POST', body: formData, headers: { Accept: 'application/json' }
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          const message = typeof result.description === 'string' ? result.description : root.dataset.addError;
          throw new Error(message);
        }
        added = true;
        button.textContent = root.dataset.addedLabel;
        if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchShopifyCart === 'function') {
          await Promise.race([
            new Promise((resolve) => {
              try { window.Rebuy.Cart.fetchShopifyCart(resolve); } catch (error) { resolve(); }
            }),
            new Promise((resolve) => window.setTimeout(resolve, 2000))
          ]);
        }
        const cartResponse = await fetch(root.dataset.cartUrl + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('Cart unavailable');
        const cartSnapshot = await cartResponse.json();
        syncDuoItems(cartSnapshot.items);
        if (root.dataset.duoInCart === 'true') {
          showCart();
          return;
        }
        const popup = await waitForDuoPopup(root.dataset.duoId);
        if (!popup) {
          showCart();
          return;
        }
        if (window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.hide === 'function') window.Rebuy.SmartCart.hide();
        popup.data.pop_up_trigger = 'manual';
        offerPending = true;
        popup.show();
      } catch (error) {
        if (added) {
          offerPending = false;
          showCart();
        } else {
          status.textContent = error.message || root.dataset.addError;
          status.hidden = false;
        }
      } finally {
        controls.forEach((control) => { control.disabled = false; });
        root.removeAttribute('aria-busy');
        button.textContent = originalLabel;
      }
    }, true);
    document.querySelectorAll('[data-kaseme-product]').forEach((root) => {
      if (root.dataset.productAvailable === 'true' && root.dataset.variantAvailable !== 'true') {
        const selector = root.querySelector('[data-kaseme-option]');
        if (selector) selector.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
